import { ClassValues } from './TournamentClasses/components/ClassesTag/ClassesTag';

export const createAndSortOptionsForClassSelect = (classList: ClassValues[]) => {
    return classList.map((option) => ({
        value: option.classId,
        label: option.name,
    }));
};